var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1030 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "201.172",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M391.85 430.08c-9.284 0-18.022-3.823-24.03-12.015l-30.583-39.868c-9.83-13.107-7.646-32.222 5.462-42.052 13.107-9.83 32.222-7.646 42.052 5.461l30.583 39.868c9.83 13.107 7.646 32.222-5.46 42.052-5.462 4.37-11.47 6.554-18.023 6.554z"
      }
    }), _c('path', {
      attrs: {
        "d": "M455.748 430.08c-6.553 0-13.107-2.185-18.568-6.554-13.107-10.376-15.292-28.945-5.462-42.052l31.13-39.868c10.377-13.107 28.945-15.291 42.052-5.46 13.107 10.376 15.292 28.944 5.462 42.051l-31.13 40.414c-5.461 7.646-14.746 11.469-23.484 11.469z"
      }
    }), _c('path', {
      attrs: {
        "d": "M507.63 449.195H334.508c-16.384 0-30.038-13.654-30.038-30.038s13.654-30.037 30.038-30.037H507.63c16.384 0 30.037 13.653 30.037 30.037s-13.653 30.038-30.037 30.038zm0 97.758H334.508c-16.384 0-30.038-13.654-30.038-30.038s13.654-30.037 30.038-30.037H507.63c16.384 0 30.037 13.653 30.037 30.037s-13.653 30.038-30.037 30.038z"
      }
    }), _c('path', {
      attrs: {
        "d": "M421.342 614.673c-16.384 0-30.037-13.653-30.037-30.037V419.157c0-16.384 13.653-30.037 30.037-30.037s30.037 13.653 30.037 30.037v165.479c0 16.384-13.653 30.037-30.037 30.037z"
      }
    }), _c('path', {
      attrs: {
        "d": "M675.84 241.118v217.36h170.394l118.51 178.587v75.366H892.11v54.613c0 49.698-40.414 90.112-90.112 90.112s-90.112-40.414-90.112-90.112v-54.613h-399.77v54.613c0 49.698-40.414 90.112-90.112 90.112s-90.112-40.414-90.112-90.112v-54.613H59.255V241.118H675.84m18.569-54.613H40.687c-20.207 0-36.045 16.384-36.045 36.044v507.358c0 20.207 16.384 36.045 36.045 36.045h36.045c0 79.735 64.99 144.725 144.725 144.725s144.725-64.99 144.725-144.725h290.543c0 79.735 64.99 144.725 144.726 144.725s144.725-64.99 144.725-144.725h36.045c20.207 0 36.045-16.384 36.045-36.045V627.234c1.092-3.277.546-6.553-1.639-9.284L879.547 411.51c-4.368-5.46-9.284-7.645-15.291-7.645H730.453V222.549c0-20.207-15.838-36.044-36.044-36.044z"
      }
    }), _c('path', {
      attrs: {
        "d": "M803.09 908.493c-80.829 0-146.365-65.536-146.365-146.364s65.536-146.364 146.364-146.364 146.364 65.536 146.364 146.364-65.536 146.364-146.364 146.364zm0-237.568c-50.245 0-91.751 40.96-91.751 91.75s40.96 91.75 91.75 91.75 91.75-40.96 91.75-91.75-40.96-91.75-91.75-91.75zM221.456 908.493c-80.828 0-146.364-65.536-146.364-146.364s65.536-146.364 146.364-146.364 146.364 65.536 146.364 146.364-66.082 146.364-146.364 146.364zm0-237.568c-50.244 0-91.75 40.96-91.75 91.75s40.96 91.75 91.75 91.75 91.75-40.96 91.75-91.75-41.506-91.75-91.75-91.75z"
      }
    })]));
  }
};